"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const generateComponentContext_1 = __importDefault(require("../generateComponentContext"));
const entities_1 = require("../../../dataStructures/entities");
const componentAttributes = (element) => {
    const data = (0, generateComponentContext_1.default)(element);
    return (0, entities_1.componentAttributesContext)(data);
};
exports.default = componentAttributes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50QXR0cmlidXRlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy91dGlscy9keW5hbWljQ29udGV4dC9lbnRpdGllcy9jb21wb25lbnRBdHRyaWJ1dGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQ0EsMkZBQW1FO0FBQ25FLCtEQUE4RTtBQUU5RSxNQUFNLG1CQUFtQixHQUFHLENBQUMsT0FBb0IsRUFBc0IsRUFBRTtJQUNyRSxNQUFNLElBQUksR0FBRyxJQUFBLGtDQUF3QixFQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQy9DLE9BQU8sSUFBQSxxQ0FBMEIsRUFBQyxJQUFJLENBQUMsQ0FBQztBQUM1QyxDQUFDLENBQUM7QUFFRixrQkFBZSxtQkFBbUIsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../../src/utils/dynamicContext/entities/componentAttributes.ts